/**
 * Shared utilities for video platform components
 */

import { format, parseISO } from "date-fns";

export const MEETING_QUERY_PARAMS = {
  prioritizeStatus: "ACTIVE",
  sortBy: "date",
  sortOrder: "desc",
  limit: 100,
} as const;

export const getStatusColor = (status: string) => {
  const statusUpper = status?.toUpperCase() || "UNKNOWN";
  switch (statusUpper) {
    case "ACTIVE":
      return { bgcolor: "#0bc68a", color: "#1a1918" };
    case "ENDED":
    case "CANCELLED":
      return { bgcolor: "#e4463a", color: "#ffffff" };
    case "CREATED":
      return { bgcolor: "#2196f3", color: "#ffffff" };
    case "INACTIVE":
      return { bgcolor: "#9e9e9e", color: "#ffffff" };
    default:
      return { bgcolor: "#9e9e9e", color: "#ffffff" };
  }
};

export const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) return "-";

  try {
    const date = parseISO(dateString);
    return format(date, "yyyy-MM-dd HH:mm");
  } catch {
    return "-";
  }
};
